//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"Distance",1,0],[0,"PlacementAngle",1,0],[0,"PlacementType",1,0],[0,"SelectMountingInterfaceLocation",1,"AME.SelectMountingInterfaceLocationBuilder",0]],[[["noOfDraggedObjects","eos"],"GetEngobjectsToBePlaced",{},0,0],[["eos"],"SetEngobjectsToBePlaced",{},1,0]],[]];
SPLM.AME.Bulk3DPlacementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.Bulk3DPlacementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.Bulk3DPlacementBuilder.PlacementTypePolicy = Object.freeze({
    "LefttoRight" : "LefttoRight", "RighttoLeft" : "RighttoLeft", "ToptoBottom" : "ToptoBottom", "BottomtoTop" : "BottomtoTop"});

SPLM.AME.Bulk3DPlacementBuilder.PlacementAnglePolicy = Object.freeze({
    "ZeroDegree" : "ZeroDegree", "NinetyDegree" : "NinetyDegree", "OneEightyDegree" : "OneEightyDegree", "TwoSeventyDegree" : "TwoSeventyDegree"});

export default SPLM;